import React from "react";
// import { Link } from "react-router-dom";

// import InstagramPNG from "../../../../assests/images/instagram.png";
// import FbPNG from "../../../../assests/images/fb.png";
// import LinkedPNG from "../../../../assests/images/linked.png";
// import TwitterPNG from "../../../../assests/images/twitter.png";
// import { post, handleError } from "../../../../shared/HttpReq";
// import { useForm } from "../../../../shared/useForm";
// import Auth from "../../../../auth/Auth";
// import { Toast } from "../../../../shared/toaster/Toaster";
// import AppContext from "../../../../shared/AppContext";
function Footer() {
  // const { companyInfo } = useContext(AppContext);


  // const [toaster, SetToaster] = useState({
  //   show: false,
  //   type: "", // type should be "danger" or "success"
  //   content: "",
  // });

  // const { values, errors, bindField } = useForm({
  //   validations: {
  //     email: {
  //       pattern: {
  //         value:
  //           /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i,
  //         message: "Invalid email address.",
  //       },
  //     },
  //   },
  // });

  // const Subscribe = async (e) => {
  //   e.preventDefault();
  //   let res = await handleError(
  //     await fetch(
  //       `${process.env.REACT_APP_BASE_URL}/subscribe`,
  //       await post(values)
  //     )
  //   );

    // let res =  await handleError(await fetch(`${process.env.REACT_APP_BASE_URL}/subscribe`, {
    //   method: "POST",
    //   headers: {
    //     "Content-Type": "application/json",
    //     Accept: "application/json",
    //   },
    //   body: JSON.stringify(values),
    // }));

  //   if (res.status === 200) {
  //     SetToaster({
  //       show: true,
  //       type: "success", // type should be "danger" or "success"
  //       content: res.message,
  //     });
  //   }

  //   if (res.status >= 400 && res.status <= 499) {
  //     SetToaster({
  //       show: true,
  //       type: "danger", // type should be "danger" or "success"
  //       content: res.message,
  //     });
  //   }
  //   setTimeout(() => {
  //     SetToaster({
  //       show: false,
  //       type: "",
  //       content: "",
  //     });
  //   }, 5000);
  // };

  return (
    <>
      {/* <Toast
        show={toaster.show}
        type={toaster.type}
        content={toaster.content}
        onClose={() =>
          SetToaster({
            show: false,
            type: "",
            content: "",
          })
        }
      /> */}
      <footer className="mobile_footer">
        <div className="container-fluid">
          <div className="footer_wrap">
            {/* <div className="footer">
              <div className="text-center">
                <h2 className="footer_heading">Subscribe to Our Newsletters</h2>
                <p className="footer_text">
                  Be the first to know about special offers and other events
                </p>
                <form action="" onSubmit={Subscribe}>
                  <div className="form-group row">
                    <div className="col-lg-9 col-md-9">
                      <input
                        type="text"
                        placeholder="Type email address"
                        className="form-control custom_search_input mb-3"
                        value={values.email}
                        {...bindField("email")}
                      />

                      {errors.email && (
                        <p className="text-danger custom-email-msg-text">
                          {errors.email}
                        </p>
                      )}
                    </div>
                    <div className="col-lg-3 col-md-3 pl-0">
                      <button className="subscribe_btn"> Subscribe</button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
           
            */}
            <footer className="footer_bottom footer_common">
              {/* <h4 className="brand_text_footer">{companyInfo.name || ""}</h4> */}

              <div className="d-flex justify-content-between w-100 footer_secondary_list">
                <div className="first_footer_list">
                  {/* <ul className="secondary_list">
                    <li className="secondary_list_item">
                      <Link
                        to={`/?id=${Auth.getCompanyHexaID()}`}
                        className="secondary_list_item_link"
                      >
                        Calendar
                      </Link>
                    </li>
                    <li className="secondary_list_item">
                      <Link
                        to="/excursion"
                        className="secondary_list_item_link"
                      >
                        Excursions
                      </Link>
                    </li>
                  </ul> */}
                </div>

                {/* <ul className="social_list">
                  <li className="social_list_item">
                    <a href="https://www.instagram.com/" className="social_list_item_link" target="_blank">
                      <img src={InstagramPNG} alt="Instagram PIC"></img>
                    </a>
                  </li>
                  <li className="social_list_item">
                    <a href="https://www.facebook.com/" className="social_list_item_link" target="_blank">
                      <img src={FbPNG} alt="FB PIC"></img>
                    </a>
                  </li>
                  <li className="social_list_item">
                    <a href="https://twitter.com/" className="social_list_item_link" target="_blank">
                      <img src={TwitterPNG} alt="Twitter PIC"></img>
                    </a>
                  </li>
                  <li className="social_list_item">
                    <a href="https://www.linkedin.com/" className="social_list_item_link" target="_blank">
                      <img src={LinkedPNG} alt="Linkdin PIC"></img>
                    </a>
                  </li>
                </ul> */}
              </div>
            </footer>
          </div>
        </div>
        <p className="powered_by">
          Powered by <span>Pelago</span>
        </p>
      </footer>
    </>
  );
}

export default Footer;
